import { render, staticRenderFns } from "./PaperTest_WebsterAdult.vue?vue&type=template&id=5f096f9e&style=height%3A%20100%25%3B"
import script from "./PaperTest_WebsterAdult.vue?vue&type=script&lang=js"
export * from "./PaperTest_WebsterAdult.vue?vue&type=script&lang=js"
import style0 from "./PaperTest_WebsterAdult.vue?vue&type=style&index=0&id=5f096f9e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports